import { useCustomization } from "../context/CustomizationContext";

export function useCustom() {
  return useCustomization();
}
